import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingSource", "productLevel", "screen", "sourceId", "use", "purchaseMotion", "purchaseMotionLocation"];
import CodeSplitEnvWrapper from '../../../components/common/env/CodeSplitEnvWrapper';
import { useAppSelector } from '../../../reducers';
import { suiteProductConfigurationsSelector } from '../../../selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtilsLegacy';
import { APP } from '../../../v2/constants/tracking/TrackingSources';
import LoadingCTA from './LoadingCTA';
import { jsx as _jsx } from "react/jsx-runtime";
const ApiNameToOverrideMap = {
  'crm-suite-starter-bundle': 'crmsuitestarterbundle',
  'crm-suite-professional-bundle': 'crmsuiteprofessionalbundle',
  'crm-suite-enterprise-bundle': 'crmsuiteenterprise'
};
export const SuiteCTA = props => {
  const {
      trackingSource,
      productLevel,
      screen,
      sourceId = 'pricing-hero',
      use = 'primary',
      purchaseMotion,
      purchaseMotionLocation
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const suiteProductConfigurations = useAppSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const apiName = `crm-suite-${productLevel.toLowerCase()}-bundle`;
  const trackingData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${productLevel.toLowerCase()}`
  };
  const ownedQuantityPackProductConfigurations = useAppSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });

  // In the case we pass in purchaseMotion by indexing purchaseMotions[0], but the purchaseMotions array is empty. TS won't complain, but it will throw an error at runtime.
  if (!purchaseMotion) return null;
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const sharedProps = Object.assign({}, rest, {
    productConfigurations: checkoutProductConfigurations,
    queryParamTerm,
    use: use || 'primary',
    purchaseMotion,
    trackingSource
  });
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, sharedProps, {
      apiName,
      trackingData,
      purchaseMotionLocation
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      sourceId,
      dtbSource: `pricing-page|${trackingSource}|suite|${productLevel.toLowerCase()}`,
      hubsSignupProductOverride: ApiNameToOverrideMap[apiName] || apiName
    }),
    authedComponentLoadingState: LoadingCTA,
    publicComponentLoadingState: LoadingCTA
  });
};